module.exports = __webpack_public_path__ + "static/img/bg_theme_purple@2x.ede0ce9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/skin/bg_theme_purple@2x.png
// module id = S3GH
// module chunks = 1